import {httpGet} from "../libs/http";

export const adminAnalyticsKeyValueReport = (month, year, report, onSuccess = null, onFailure = null) => dispatch => {
    httpGet('/admin/analytics/key-value-report/?month=' + month + '&year=' + year + '&report=' + report, (res) => onSuccess(res), (err) => onFailure(err));
}
